













import {
  Vue,
  Component,
  Prop
} from "vue-property-decorator";

@Component({
  components: {},
})
export default class CardConent extends Vue {
    @Prop()
    public imgSrc!: String;
    @Prop()
    public value!: String;
    @Prop() 
    public label!: String;
    @Prop()
    public containeWidth?: Number;
    @Prop()
    public containeHeight?: Number;
    @Prop({default:false})
    public alignLabel?: boolean;

    get containerStyle () {
        if(this.containeHeight){
            return {
                height: this.containeHeight + 'px'
            }
        }
        else if (this.containeWidth) {
            return {
                height: this.containeWidth + 'px'
            }
        } else {
            return
        }
    }
}
